/**
 * Equation presets for the equation-balance experiment.
 * These are the canned equation problems students can work through.
 */

export interface EquationPreset {
  id: string;
  equation: string;
}

export const EQUATION_PRESETS: readonly EquationPreset[] = [
  { id: 'one-step', equation: '2x = 8' },
  { id: 'two-step', equation: '2x + 3 = 11' },
  { id: 'both-sides', equation: '5x - 4 = 2x + 8' },
  { id: 'negative-x', equation: '7 - 2x = 3' },
  { id: 'distribute', equation: '3(x - 1) = 9' },
];

/**
 * Validate that a preset has all required fields and valid structure.
 */
export function isValidPreset(p: EquationPreset): boolean {
  // id must be non-empty string
  if (typeof p.id !== 'string' || p.id.length === 0) {
    return false;
  }

  // equation must contain an equals sign
  if (typeof p.equation !== 'string' || !p.equation.includes('=')) {
    return false;
  }

  return true;
}
